import { supabase } from "@/integrations/supabase/client";

export async function getRsvpsByCollection(collectionId: string) {
  const { data, error } = await supabase
    .from("rsvps")
    .select("*")
    .eq("collection_id", collectionId)
    .order("created_at", { ascending: true });
  return { data: data || [], error };
}

export async function getRsvpByEmail(collectionId: string, email: string) {
  const { data, error } = await supabase
    .from("rsvps")
    .select("*")
    .eq("collection_id", collectionId)
    .eq("guest_email", email)
    .maybeSingle();
  return { data, error };
}

export async function createRsvp(rsvp: {
  collection_id: string;
  guest_name: string;
  guest_email?: string;
  response: string;
  plus_one?: boolean;
  plus_one_name?: string;
  rsvp_answers?: Record<string, string | string[]>;
}) {
  // If email provided, check for existing RSVP and update it
  if (rsvp.guest_email) {
    const { data: existing } = await getRsvpByEmail(rsvp.collection_id, rsvp.guest_email);
    if (existing) {
      const { data, error } = await supabase
        .from("rsvps")
        .update({
          guest_name: rsvp.guest_name,
          response: rsvp.response,
          plus_one: rsvp.plus_one || false,
          plus_one_name: rsvp.plus_one_name || null,
          rsvp_answers: (rsvp.rsvp_answers || {}) as any,
        })
        .eq("id", existing.id)
        .select()
        .single();
      return { data, error, updated: true };
    }
  }

  const { data, error } = await supabase
    .from("rsvps")
    .insert({
      ...rsvp,
      rsvp_answers: (rsvp.rsvp_answers || {}) as any,
    })
    .select()
    .single();
  return { data, error, updated: false };
}

export async function getRsvpCounts(collectionId: string) {
  const { data } = await supabase
    .from("rsvps")
    .select("response, plus_one")
    .eq("collection_id", collectionId);

  const yes = data?.filter(r => r.response === "yes").length || 0;
  const no = data?.filter(r => r.response === "no").length || 0;
  const plusOnes = data?.filter(r => r.response === "yes" && r.plus_one).length || 0;

  return { yes, no, plusOnes, total: yes + no };
}
